"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _ImageTag = _interopRequireDefault(require("../ImageTag"));
var _ImagePreloader = _interopRequireDefault(require("../ImagePreloader"));
var _Dialog = _interopRequireDefault(require("material-ui/Dialog"));
var _cloudinaryReact = require("cloudinary-react");
var _isUndefined2 = _interopRequireDefault(require("lodash/isUndefined"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _map2 = _interopRequireDefault(require("lodash/map"));
require("./SequenceContainer.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } //import cloudinary from "cloudinary-core";
/**
* SequenceContainer
this component is an element that can be added alongside other elements of a scene
he holds an array of playlist that are "looped" through
most of the time this will be "run" in a modal
so display a poster
some parts are only needed for cms editing, the cms may also need to pass more info in the props than destination would
<div class="sequence-container" (conditional:isEditMode)>
    <div class="(image|video|audio)-container">
      <img> | <video> | <audio>
      <div class="asset-text" (conditional:showCaption)/>
      
  
*/
var AssetText = function AssetText(props) {
  if (props.show && props.metaConfig) {
    var _props$metaConfig = props.metaConfig,
      title = _props$metaConfig.title,
      caption = _props$metaConfig.caption,
      caption2 = _props$metaConfig.caption2;
    var fullCaption = caption + (caption2 || "");
    //console.log("[CaptionArea] props:", props);
    return /*#__PURE__*/_react["default"].createElement("section", {
      className: "asset-text"
    }, title ? /*#__PURE__*/_react["default"].createElement("h6", {
      dangerouslySetInnerHTML: {
        __html: title
      }
    }) : null, caption ? /*#__PURE__*/_react["default"].createElement("div", {
      dangerouslySetInnerHTML: {
        __html: fullCaption
      }
    }) : null);
  } else {
    return null;
  }
};
var SpriteContainer = function SpriteContainer(props) {
  //console.log('[SEQUENCE CONTAINER] SpriteArea ', props);
  var elements = props.elements,
    advanceFunc = props.advanceFunc;
  var buttons = [];
  if (!(0, _isEmpty2["default"])(elements)) {
    // loop and add buttons
    (0, _map2["default"])(elements, function (element, index) {
      var label = element.text ? element.text.en || element.text : '-';
      //const direction = true:false;
      buttons.push( /*#__PURE__*/_react["default"].createElement("button", {
        className: "button1 sequence-button",
        key: index,
        onClick: function onClick() {
          return advanceFunc(true);
        }
      }, label));
    });
  } else {
    // temp
    //buttons.push(<button onClick={()=>advanceFunc(false)}> prev</button>);
    //buttons.push(<button onClick={()=>advanceFunc(true)}> next</button>);
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "sprite-container"
  }, buttons);
};

// the asset display..
var SequenceAsset = function SequenceAsset(props) {
  /*
  when the advance is triggered, we look to the asset in the array to build out what should be displayed...
  we may end up having a switch here - or might be able to reference the AssetContainer....
  we will potentially load a different asset type 
  */
  console.log('[SEQUENCE CONTAINER] SequenceAsset ', props);
  var className = props.className,
    cloudName = props.cloudName,
    cloudPublicId = props.cloudPublicId,
    vidType = props.vidType,
    advanceFunc = props.advanceFunc,
    vidRef = props.vidRef,
    elements = props.elements,
    autoAdvance = props.autoAdvance,
    posterSrc = props.posterSrc;
  var src = props.src,
    vidProps = props.vidProps,
    useCloudinary = props.useCloudinary;
  var vidTypes = ["mp4", "ogg", "webm"];
  //const vidStyle = {height:"94%"}
  // we have to set a src value if not using the cloudinary- so forcing it for now
  // can't seem to get the targeting to work when using the cloudinay
  if (!src) {
    useCloudinary = false;
    src = "".concat(location.protocol, "//res.cloudinary.com/").concat(cloudName, "/video/upload/v1/").concat(cloudPublicId);
  }
  if (autoAdvance === "loop") {
    vidProps = _objectSpread(_objectSpread({}, vidProps), {}, {
      loop: true
    });
  }
  var endFunc = autoAdvance === "next" ? function () {
    return advanceFunc(true);
  } : function () {};
  //             

  // NOTE if offline, may not need to write all three source tags, since we only download mp4
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(className, " asset col")
  }, useCloudinary ? /*#__PURE__*/_react["default"].createElement(_cloudinaryReact.Video, _extends({
    id: 'sequence-player',
    className: "cld-video-player cld-fluid",
    ref: vidRef,
    publicId: cloudPublicId,
    cloudName: cloudName,
    poster: posterSrc,
    onEnded: endFunc
  }, vidProps, {
    autoPlay: true
  })) : /*#__PURE__*/_react["default"].createElement("video", _extends({
    id: 'sequence-player',
    ref: vidRef
  }, vidProps, {
    poster: posterSrc,
    onEnded: endFunc,
    autoPlay: true
  }), vidTypes.map(function (vtype, index) {
    return /*#__PURE__*/_react["default"].createElement("source", {
      key: index,
      src: "".concat(src, ".").concat(vtype),
      type: "video/".concat(vtype)
    });
  })), /*#__PURE__*/_react["default"].createElement(SpriteContainer, {
    advanceFunc: advanceFunc,
    elements: elements
  }));
};
var SequenceContainer = /*#__PURE__*/function (_Component) {
  _inherits(SequenceContainer, _Component);
  var _super = _createSuper(SequenceContainer);
  function SequenceContainer(props) {
    var _this;
    _classCallCheck(this, SequenceContainer);
    _this = _super.call(this, props);
    _this.state = {
      openModal: false,
      activeIndex: 0,
      nextIndex: 1
    };
    _this.processEditClick = _this.processEditClick.bind(_assertThisInitialized(_this));
    _this.closeModal = _this.closeModal.bind(_assertThisInitialized(_this));
    _this.openModal = _this.openModal.bind(_assertThisInitialized(_this));
    _this.advanceSequence = _this.advanceSequence.bind(_assertThisInitialized(_this));
    _this.videoPLayer;
    return _this;
  }

  // right now the modal is only used for playlist that are videos....
  _createClass(SequenceContainer, [{
    key: "closeModal",
    value: function closeModal() {
      this.setState({
        openModal: false,
        activeIndex: 0
      });
    }
  }, {
    key: "openModal",
    value: function openModal(elementID) {
      console.log("[SEQUENCE-CONTAINER] openModal:", elementID);
      this.setState({
        openModal: true
      });
    }

    // sequencing
  }, {
    key: "advanceSequence",
    value: function advanceSequence(direction) {
      var activeIndex = this.state.activeIndex;
      var playlist = this.props.playlist;
      console.log("[SEQUNCE] advance function click", this.props, ', next?', direction, ', state:', this.state);
      // change the activeIndex based on next variable
      // make sure we don't go beyond or below total playlist...
      var newIndex = direction ? activeIndex + 1 : activeIndex - 1;
      var nextIndex = newIndex + 1;
      if (newIndex >= playlist.length) {
        newIndex = 0;
        nextIndex = 1;
      }
      if (newIndex < 0) {
        newIndex = playlist.length - 1;
        nextIndex = 0;
      }
      //if(this.videoPlayer){
      //this.videoPlayer.pause();
      //}
      // changing the state then updates the video source
      this.setState({
        activeIndex: newIndex,
        nextIndex: nextIndex
      });
    }

    // Functions used by Editing Mode
  }, {
    key: "processEditClick",
    value: function processEditClick(value, event) {
      event.preventDefault();
      event.stopPropagation();
      if (typeof this.props.triggerEditFunc !== "undefined" && this.props.isEditMode) {
        this.props.triggerEditFunc(value);
      }
    }
  }, {
    key: "assetIsSet",
    value: function assetIsSet(asset) {
      return typeof this.props !== "undefined" && (typeof this.props.cloudPublicId !== "undefined" || typeof this.props.src !== "undefined");
    }

    /**
    sequence1 : {
      type: "sequence",
      use: "sequence1",
      playlist : [
        {
          autoAdvance: "next",
          assetID : "5ace1e209d63e964941048c3",
          assetType : "video",
          cloudPublicId : "9bc41362d65b424a980c1ee7/carbon-capture-clip-01-intro_luhsig",
          elements : {}
        },
        {
          autoAdvance: "loop",
          assetID : "5ace1e209d63e964941048c4",
          assetType : "video",
          cloudPublicId : "9bc41362d65b424a980c1ee7/carbon-capture-clip-01-loop_kaefxx",
          elements : {
              sprite1 : {
                entry : "00:00:00",
                exit : "00:00:00",
                type : "button",
                use : "sprite1",
                text : {en:"Continue"}
              },
          }
        },
        {
          autoAdvance: "none",
          assetID : "5ace1e209d63e964941048c5",
          cloudPublicId : "9bc41362d65b424a980c1ee7/carbon-capture-clip-02-intro_ysjxno",
          src : "path/to/offline/video/file",
          elements : { }
        }            
      ]
    }
    */
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        layout = _this$props.layout,
        className = _this$props.className,
        isEditMode = _this$props.isEditMode,
        elementID = _this$props.elementID,
        assetFit = _this$props.assetFit,
        isActiveEditingElement = _this$props.isActiveEditingElement,
        assetSelectorFunc = _this$props.assetSelectorFunc,
        playlist = _this$props.playlist;
      // console.log('[SEQUENCE CONTAINER] props', this.props, ', state', this.state);
      //console.log("[ASSETCONTAINER] props:", this.props);

      // NOTE we need the abiilty if we are in edit mode to 
      // 1. add a special onClick function
      // 2. allow the different types

      var content;
      var showTextClass = showAssetText ? "with-text" : "";
      var extension = /(?:\.([^.]+))?$/;
      var clickFunc = isEditMode ? function (event) {
        event.preventDefault();
        event.stopPropagation();
        _this2.assetIsSet() ? _this2.processEditClick(elementID, event) : assetSelectorFunc(elementID);
      } : null;
      var editClass = isEditMode ? "edit-mode ".concat(layout, " ").concat(isActiveEditingElement ? "active-editing" : "", " ").concat(this.assetIsSet() ? "" : "no-image") : "";

      // target the activeAsset
      var activeAsset = playlist[this.state.activeIndex];
      // target props
      var assetID = activeAsset.assetID,
        assetType = activeAsset.assetType,
        cloudName = activeAsset.cloudName,
        cloudPublicId = activeAsset.cloudPublicId,
        assetConfig = activeAsset.assetConfig,
        src = activeAsset.src,
        showAssetText = activeAsset.showAssetText,
        metaConfig = activeAsset.metaConfig,
        controls = activeAsset.controls,
        autoPlay = activeAsset.autoPlay,
        loop = activeAsset.loop,
        playAsModal = activeAsset.playAsModal,
        triggerModalFunc = activeAsset.triggerModalFunc,
        poster = activeAsset.poster,
        posterSrc = activeAsset.posterSrc;
      // first pull from the props, however the modal is always autoplay
      var vidProps = {
        controls: controls,
        autoPlay: autoPlay,
        loop: loop,
        poster: poster
      };
      var useCloudinary = src ? false : true;
      var vidType = 'mp4'; // this can later be read from project data and passed down 
      // be sure backgronds ARE never played as modal
      if (playAsModal || (0, _isUndefined2["default"])(playAsModal)) {
        // MODAL PLAYBACK VIDEO
        vidProps = {
          autoPlay: autoPlay,
          loop: loop
        }; //don't have controlls on modal
        // the posterframe will be a special url
        // for a sequence - the "thumb" will use poster of first asset in the sequence array
        // for the first poster frame that shows we use the default, for all the rest we will want the first frame
        // we also need to target the next in the list in order to preload the poster frame
        var _imgPosterSrc = useCloudinary ? "".concat(location.protocol, "//res.cloudinary.com/").concat(cloudName, "/video/upload/").concat(this.state.activeIndex > 0 || this.state && this.state.openModal ? 'so_0.01/' : '').concat(cloudPublicId, ".jpg") : posterSrc;
        console.log('[SEQUENCE CONTAINER] activeAsset', activeAsset);
        content = /*#__PURE__*/_react["default"].createElement("div", {
          className: "".concat(className, " video-poster-frame-container ").concat(showTextClass),
          onClick: isEditMode ? null : this.openModal
        }, /*#__PURE__*/_react["default"].createElement(_ImageTag["default"], {
          src: _imgPosterSrc,
          className: "img-wrapper",
          isPoster: true,
          cloudPublicId: cloudPublicId,
          layout: layout
        }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
          icon: "play",
          className: "play"
        })), /*#__PURE__*/_react["default"].createElement(AssetText, {
          show: isEditMode ? false : showAssetText,
          metaConfig: metaConfig
        }), isEditMode ? null : /*#__PURE__*/_react["default"].createElement(_Dialog["default"], {
          className: "asset-modal ".concat(layout),
          modal: true,
          open: this.state && this.state.openModal,
          onRequestClose: this.closeModal,
          autoScrollBodyContent: false,
          paperClassName: 'modal-paper',
          overlayClassName: "modal-overlay",
          bodyClassName: "modal-body",
          contentClassName: "modal-content",
          title: /*#__PURE__*/_react["default"].createElement("header", null, /*#__PURE__*/_react["default"].createElement("div", {
            className: "modal-close",
            onClick: this.closeModal
          }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
            icon: "close"
          })))
        }, /*#__PURE__*/_react["default"].createElement("section", {
          className: "sequence-content"
        }, /*#__PURE__*/_react["default"].createElement(SequenceAsset, _extends({
          className: className,
          vidRef: function vidRef(el) {
            return _this2.videoPlayer = el;
          },
          useCloudinary: useCloudinary,
          vidProps: vidProps,
          vidType: vidType,
          advanceFunc: this.advanceSequence
        }, activeAsset, {
          posterSrc: _imgPosterSrc
        })), /*#__PURE__*/_react["default"].createElement(_ImagePreloader["default"], {
          isPoster: true,
          cloudName: cloudName,
          preloadList: [playlist[this.state.nextIndex]],
          frame: "so_0.01/"
        }))));
      } else {
        // INLINE PLAYBACK VIDEO
        content = /*#__PURE__*/_react["default"].createElement("div", {
          className: "".concat(editClass, " ").concat(className, " sequence-container ").concat(showTextClass),
          onClick: clickFunc
        }, /*#__PURE__*/_react["default"].createElement(SequenceAsset, _extends({
          className: className,
          useCloudinary: useCloudinary,
          vidRef: function vidRef(el) {
            return _this2.videoPlayerRef = el;
          },
          vidProps: vidProps,
          vidType: vidType
        }, activeAsset, {
          posterSrc: imgPosterSrc,
          advanceFunc: this.advanceSequence
        })), /*#__PURE__*/_react["default"].createElement(AssetText, {
          show: isEditMode ? false : showAssetText,
          metaConfig: metaConfig
        }), /*#__PURE__*/_react["default"].createElement(_ImagePreloader["default"], {
          isPoster: true,
          cloudName: cloudName,
          preloadList: [playlist[this.state.nextIndex]]
        }));
      }

      // if we are Editing and there is nothing add the placeholder
      if ((0, _isEmpty2["default"])(playlist) && isEditMode) {
        content = /*#__PURE__*/_react["default"].createElement("div", {
          className: "empty-selector ".concat(editClass, " ").concat(className),
          onClick: clickFunc
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "click-to-edit-container"
        }, /*#__PURE__*/_react["default"].createElement("h3", null, "Click to Edit")));
      }

      //console.log('[SEQUENCE CONTAINER] decide what to return...');
      if ((0, _isEmpty2["default"])(playlist) && !isEditMode) {
        // nothing to write out if the data isnt there
        // just as a catch if not editing AND no asset is present 
        return null;
      } else {
        return content;
      }
    }

    // Preload poster images at the earliest possible lifecycle event
    // NOTE: not sure we want this here, seems like only if its inline, so started a simple preload component
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this3 = this;
      //console.log("[SEQUENCE CONTAINER] onComponentDidUpdate prevState.activeIndex:",prevState.activeIndex ,"state.activeIndex", this.state.activeIndex);
      //console.log("[SEQUENCE CONTAINER] onComponentDidUpdate, modal:", this.state.openModal);
      if (this.state.openModal === true) {
        //console.log("[SEQUENCE CONTAINER] onComponentDidUpdate videoPlayer:", this.videoPlayer);
        //console.log("[SEQUENCE CONTAINER] onComponentDidUpdate this.videoPlayerRef:", this.videoPlayerRef);
        // check to only the first time...
        //if(!this.videoPlayer ){
        // could do a check for isCloudinary here to determine how to target
        //let activeAsset = this.props.playlist[this.state.activeIndex];
        //  const cloudinaryCore = new cloudinary.Cloudinary({cloud_name: activeAsset.cloudName});
        //console.log("[SEQUENCE CONTAINER] cloudinaryCore ->", cloudinaryCore);
        //this.videoPlayer = cloudinaryCore.video('sequence-player'); // use the core to target?
        //this.videoPlayer.playlist(this.props.playlist);
        //console.log("[SEQUENCE CONTAINER] videoPlayer ->", this.videoPlayer);
        //const seqPlayer = document.getElementById('sequence-player');
        //  }else 
        if (this.videoPlayer && prevState.activeIndex !== this.state.activeIndex) {
          // NOTE i dont like using a timeOut but just not sure how else to accomplish, without it there is an odd flicker when switching because the previous video is still playing
          this.videoPlayer.pause();
          var pause = setTimeout(function () {
            clearTimeout(pause);
            _this3.videoPlayer.load();
          }, 500);
          //console.log("[SEQUENCE CONTAINER] onComponentDidUpdate this.videoPlayer:", this.videoPlayer);
        }
        //
      }
    }
  }]);
  return SequenceContainer;
}(_react.Component);
var _default = SequenceContainer;
exports["default"] = _default;